<template>
    <div class="data-wrapper-core">
        <h3>Kerndaten</h3>
        <v-divider></v-divider>
        <h4>Agentur-Name:</h4>
        <p>{{ agency.style.companyName }}</p>
        <h4>Agentur-ID:</h4>
        <p>{{ agency._id }}</p>
        <h4>Agentur-Email:</h4>
        <p>{{ agency.email }}</p>
        <h4>Domain:</h4>
        <p :style="{ color: agency.domain ? '' : 'red' }">{{ agency.domain || 'KEINE DOMAIN VERKNÜPFT' }}</p>
        <h4>Slotanzahl:</h4>
        <p>Gesamt: {{ agency.amountSlots }}</p>
        <h4>Erstelldatum:</h4>
        <p>{{ agencyCreatedAt }} ({{ daysDiff }})</p>
        <h4>Betazugang:</h4>
        <p :style="{color: agency.style.betaAccess ? 'green' : '' }">{{ agency.style.betaAccess }}</p>
        <h4>WhatsApp-Beta:</h4>
        <p :style="{color: agency.style.whatsAppAccess ? 'green' : '' }">{{ agency.style.whatsAppAccess }}</p>
        <h4>Portal Builder:</h4>
        <p :style="{color: agency.style.portalBuilderAccess ? 'green' : '' }">{{ agency.style.portalBuilderAccess }}</p>
    </div>
</template>

<script>


export default {
    props: {
        agency: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            agencyCreatedAt: new Date(this.agency.createdAt).toLocaleDateString('de-DE'),
            daysDiff: null,
        }
    },
    computed: {
        // calculate the days since the agency was created
        daysSinceCreation() {
            const today = new Date();
            const creationDate = new Date(this.agency.createdAt);
            const timeDiff = Math.abs(today.getTime() - creationDate.getTime());
            const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (daysDiff < 60) {
                return `${daysDiff} Tage`;
            } else if (daysDiff < 390) {
                const months = Math.floor(daysDiff / 30);
                return `${months} Monate`;
            } else {
                const years = Math.floor(daysDiff / 365);
                const remainingMonths = Math.floor((daysDiff % 365) / 30);
                return `${years} Jahre und ${remainingMonths} Monate`;
            }
        },
    },
    mounted() {
        this.daysDiff = this.daysSinceCreation;
    }
};
</script>

<style lang="scss" scoped>
</style>